// @flow

import { keyframes } from 'styled-components';

export default keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;
